import axios from "axios";
import {ORDER_API} from "../constants/apiUrls";
// import {getUserInfo, orderApiUrl} from "utils/CommonUtils";

// 사장님 주문내역 리스트 조회
export const getOrderCeoApi = async (data) => {
  const response = await axios.get(`${ORDER_API}/order/ceo`, {
    headers: {Authorization: `Bearer ceo`},
    params: data
  });
  return response.data;
}


/**
 * 이하 함수는 서버 대상 식별 불가
 * 함수 내부 주석처리
 * 
 * @date 2026-04-17
 * @author Saccharin01
 */

// new 주문 리스트 조회
export const getOrderListApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // const response = await axios.get(`${newTestApiUrl}/ceo/orders`, {
  //   headers: {Authorization: `Bearer ${accessToken}`},
  //   params: data
  // });
  // return response.data;
}

// new 주문 리스트 조회
export const getOrderDetailApi = async (orderId) => {
  // const {accessToken} = getUserInfo();

  // const response = await axios.get(`${newTestApiUrl}/ceo/orders/${orderId}`, {
  //   headers: {Authorization: `Bearer ${accessToken}`}
  // });
  // return response.data;
}
